import * as turf from "@turf/turf";
import { useCallback, useMemo } from "react";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import GeometryService from "../services/geometryService";

export default function (center: IGeoCoordinate | undefined, miles: number): ICircleInfo | null {
    const geometryService = useMemo(() => new GeometryService(), []);
    const shape = useMemo(() => center ? geometryService.mapPolygonToShape(turf.circle([center.longitude, center.latitude], miles, { units: 'miles' }).geometry) : null, [center, miles]);

    const isPointInside = useCallback((coordinate: IGeoCoordinate): boolean => {
        return geometryService.isPointInsideShape(coordinate, shape!);
    }, [center, miles]);

    const getDistanceFromCenter = useCallback((coordinate: IGeoCoordinate): number => {
        const from = turf.point([center!.longitude, center!.latitude]);
        const to = turf.point([coordinate.longitude, coordinate.latitude]);
        return turf.distance(from, to, { units: 'miles' });
    }, [center, miles]);

    return useMemo(() => shape ? {
        isPointInside,
        getDistanceFromCenter,
    } : null, [shape, isPointInside, getDistanceFromCenter]);
}

export interface ICircleInfo {
    isPointInside: (coordinate: IGeoCoordinate) => boolean;
    getDistanceFromCenter: (coordinate: IGeoCoordinate) => number;
}